/* @flow */
import * as React from 'react';

const Expand = props => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round">
      <g transform="translate(-335.000000, -431.000000)" stroke="#677BC5" strokeWidth="2">
        <g id="Avatars" transform="translate(0.000000, 419.000000)">
          <g id="Current-location-trigger" transform="translate(323.000000, 0.000000)">
            <g id="maximize-2" transform="translate(13.000000, 13.000000)">
              <polyline id="Shape" points="9 0 14 0 14 5" />
              <polyline id="Shape" points="5 14 0 14 0 9" />
              <path d="M14,0 L9,5" id="Shape" />
              <path d="M0,14 L5,9" id="Shape" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Expand;



// WEBPACK FOOTER //
// ./src/assets/images/icons/expand.js